export class WordConverter {

    public static paymentAmountStringToWords(numberString: string): string {
        var result: string = ''; 
        result = this.convertNumToWords(Number(numberString.split('.')[0]));
            if (numberString.split('.')[1] === undefined) {
                result = `${result} Dollars and .00/100`
            } else {

                if (Number(numberString.split('.')[1]) < 10 && numberString.split('.')[1] != "00") {
                    result = `${result} Dollars and .${numberString.split('.')[1]}0/100`
                } else {
                    result = `${result} Dollars and .${numberString.split('.')[1]}/100`
                }
            }
        return result; 
    }

    public static  convertNumToWords(n: number): string {
        if (n < 0) {
            return "";
        }
        const single_digit: string[] = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const double_digit: string[] = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const below_hundred: string[] = ['Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        if (n === 0) return 'Zero';
        function translate(n: number): string {
            let word: string = "";
            if (n < 10) {
                word = single_digit[n] + ' ';
            }
            else if (n < 20) {
                word = double_digit[n - 10] + ' ';
            }
            else if (n < 100) {
                const rem: string = translate(n % 10);
                word = below_hundred[(n - n % 10) / 10 - 2] + ' ' + rem;
            }
            else if (n < 1000) {
                word = single_digit[Math.trunc(n / 100)] + ' Hundred ' + translate(n % 100);
            }
            else if (n < 1000000) {
                word = translate(parseInt(String(n / 1000))).trim() + ' Thousand ' + translate(n % 1000);
            }
            else if (n < 1000000000) {
                word = translate(parseInt(String(n / 1000000))).trim() + ' Million ' + translate(n % 1000000);
            }
            else {
                word = translate(parseInt(String(n / 1000000000))).trim() + ' Billion ' + translate(n % 1000000000);
            }
            return word;
        }
        const result: string = translate(n);
        return result.trim();
    }
}


